import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "table-wrapper" }

import { computed, ref, reactive, h, onMounted } from 'vue';
import { ElAlert, ElMessageBox } from 'element-plus';
import { EMessage } from '@aciga/e-ui-next';
import { cloneDeep } from 'lodash';
import EDrawer from '@/components/bussiness/e-drawer/index.vue';
import { getDepartmentText } from '@/utils/index';
import { accountStatusTextMap, accountStatusColorMap } from '@/config/const';
import { getVirtualGroupUser, bindUser, unbindUser } from '@/api/virtualGroup';
import AddUserDrawer from './addUserDrawer.vue';
import Pagination from '@/components/bussiness/Pagination/Index.vue';

interface Props {
  drawerVisible: boolean;
  itemInfo: {
    groupId: number;
    groupName: string;
  };
}


export default /*#__PURE__*/_defineComponent({
  __name: 'editVGroupUserDrawer',
  props: {
    drawerVisible: { type: Boolean, default: false },
    itemInfo: { default: () => ({
    groupId: 0,
    groupName: ''
  }) }
  },
  emits: ['update:drawerVisible', 'on-success'],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

const drawerShow = computed({
  get: () => props.drawerVisible,
  set: (val) => {
    emit('update:drawerVisible', val);
  }
});

const tableList = ref<VirtualGroup.UserItem[]>([]);
let allAddUserList: VirtualGroup.UserItem[] = [];
let originAddUserList: VirtualGroup.UserItem[] = []; // 记录初始值，用于区分新增和删除用户
const paginationObj = reactive({
  pageNum: 1,
  pageSize: 10,
  totalCount: 0
});

// 前端分页
const frontGetTableData = () => {
  const { pageNum, pageSize } = paginationObj;
  tableList.value = allAddUserList.slice((pageNum - 1) * pageSize, pageNum * pageSize);
  paginationObj.totalCount = allAddUserList.length;
};

onMounted(async () => {
  const res = await getVirtualGroupUser(props.itemInfo.groupId);
  const { code, data } = res;
  if (`${code}` === '0') {
    allAddUserList = data.users as VirtualGroup.UserItem[];
    originAddUserList = cloneDeep(data.users as VirtualGroup.UserItem[]);
  }
  frontGetTableData();
});

// 添加用户抽屉
const addUserDrawerVisiable = ref(false);
const addUserList = ref<VirtualGroup.UserItem[]>([]);
const openAddUserDrawer = () => {
  addUserList.value = cloneDeep(allAddUserList);
  addUserDrawerVisiable.value = true;
};
// 子抽屉关闭后，刷新已添加用户
const onChangeAddUser = (list: VirtualGroup.UserItem[]) => {
  allAddUserList = cloneDeep(list);
  frontGetTableData();
};

const onDelUser = (row: VirtualGroup.UserItem) => {
  const index = allAddUserList.findIndex((user) => user.uid === row.uid);
  if (index >= 0) {
    allAddUserList.splice(index, 1);
    frontGetTableData();
  }
};

const onConfirm = () => {
  const { itemInfo } = props;
  const allAddUserIds = allAddUserList.map((e) => e.uid);
  const originAddUserIds = (originAddUserList || []).map((e) => e.uid);

  // 取差集
  const bindUids: number[] = allAddUserIds.filter(
    (uid) => !originAddUserIds.includes(uid)
  ) as number[];
  // 取差集
  const unbindUids: number[] = originAddUserIds.filter(
    (uid) => !allAddUserIds.includes(uid)
  ) as number[];
  const reqArr = [];
  if (bindUids.length > 0) {
    const params = {
      groupId: itemInfo.groupId,
      uids: bindUids
    };
    reqArr.push(bindUser(params));
    // if (`${res.code}` === '0') {
    //   EMessage.success('修改成功');
    //   drawerShow.value = false;
    // }
  }
  if (unbindUids.length > 0) {
    const params = {
      groupId: itemInfo.groupId,
      uids: unbindUids
    };
    reqArr.push(unbindUser(params));
  }
  Promise.all(reqArr)
    .then((resArr) => {
      const isSuccess = resArr.every((res) => `${res.code}` === '0');
      if (isSuccess) {
        EMessage.success('修改成功');
        drawerShow.value = false;
      }
    })
    .catch((e) => {
      console.log(e);
    });
};

const onCancel = () => {
  // @ts-ignore
  ElMessageBox.confirm(
    h(ElAlert, {
      title: '确认关闭虚拟组用户编辑，取消对虚拟组用户的修改',
      type: 'warning',
      showIcon: true,
      closable: false
    }),
    '关闭虚拟组用户编辑',
    {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      customClass: 'e-message-box e-theme-cm',
      confirmButtonClass: 'e-button el-button--main e-theme-cm',
      cancelButtonClass: 'e-button el-button--secondary e-theme-cm',
      effect: 'cm'
    }
  ).then(async () => {
    drawerShow.value = false;
  });
};

return (_ctx: any,_cache: any) => {
  const _component_e_form_item = _resolveComponent("e-form-item")!
  const _component_e_form = _resolveComponent("e-form")!
  const _component_e_button = _resolveComponent("e-button")!
  const _component_e_block = _resolveComponent("e-block")!
  const _component_e_table_column = _resolveComponent("e-table-column")!
  const _component_e_status = _resolveComponent("e-status")!
  const _component_e_table = _resolveComponent("e-table")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(EDrawer, {
      modelValue: drawerShow.value,
      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((drawerShow).value = $event)),
      direction: "rtl",
      title: "编辑用户",
      size: "60%",
      "show-footer": true,
      "close-on-click-modal": false,
      "close-on-press-escape": false,
      "show-close": false,
      "confirm-text": "确定",
      "cancel-text": "取消",
      onConfirm: onConfirm,
      onCancel: onCancel
    }, {
      default: _withCtx(() => [
        _createVNode(_component_e_form, {
          ref: "formRef",
          class: "detail-form",
          "label-width": "90px",
          "label-position": "right",
          "show-ellipsis": false
        }, {
          default: _withCtx(() => [
            _createVNode(_component_e_form_item, { label: "虚拟组ID" }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.itemInfo.groupId), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_e_form_item, { label: "虚拟组名称" }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.itemInfo.groupName), 1)
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 512),
        _createElementVNode("div", _hoisted_1, [
          _createVNode(_component_e_block, {
            title: "已添加用户列表",
            sider: false
          }, {
            "header-right": _withCtx(() => [
              _createVNode(_component_e_button, { onClick: openAddUserDrawer }, {
                default: _withCtx(() => [
                  _createTextVNode("添加用户")
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_e_table, {
            data: tableList.value,
            border: ""
          }, {
            default: _withCtx(() => [
              _createVNode(_component_e_table_column, {
                label: "用户ID",
                prop: "uid",
                "min-width": "150px",
                align: "center"
              }),
              _createVNode(_component_e_table_column, {
                label: "用户名称",
                prop: "userName",
                "min-width": "100px"
              }),
              _createVNode(_component_e_table_column, {
                label: "手机号",
                prop: "mobile",
                "min-width": "150px"
              }, {
                default: _withCtx((scope) => [
                  _createTextVNode(_toDisplayString(scope.row.mobile ? scope.row.mobile.replace(/(\d{5})\d{4}(\d*)/g, '$1****$2') : ''), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_e_table_column, {
                label: "组织",
                prop: "departments",
                "min-width": "200px"
              }, {
                default: _withCtx((scope) => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(scope.row.departments, (item, index) => {
                    return (_openBlock(), _createElementBlock("p", { key: index }, _toDisplayString(_unref(getDepartmentText)(item)), 1))
                  }), 128))
                ]),
                _: 1
              }),
              _createVNode(_component_e_table_column, {
                label: "状态",
                prop: "status",
                "min-width": "100px"
              }, {
                default: _withCtx((scope) => [
                  (typeof scope.row.status === 'number')
                    ? (_openBlock(), _createBlock(_component_e_status, {
                        key: 0,
                        label: _unref(accountStatusTextMap).get(scope.row.status),
                        type: _unref(accountStatusColorMap).get(scope.row.status)
                      }, null, 8, ["label", "type"]))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              }),
              _createVNode(_component_e_table_column, {
                label: "操作",
                align: "center"
              }, {
                default: _withCtx((scope) => [
                  _createVNode(_component_e_button, {
                    size: "mini",
                    type: "warning",
                    plain: "",
                    onClick: ($event: any) => (onDelUser(scope.row))
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("删除")
                    ]),
                    _: 2
                  }, 1032, ["onClick"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["data"])
        ]),
        _createVNode(Pagination, {
          pageNo: paginationObj.pageNum,
          "onUpdate:pageNo": _cache[0] || (_cache[0] = ($event: any) => ((paginationObj.pageNum) = $event)),
          pageSize: paginationObj.pageSize,
          "onUpdate:pageSize": _cache[1] || (_cache[1] = ($event: any) => ((paginationObj.pageSize) = $event)),
          total: paginationObj.totalCount,
          onPagination: frontGetTableData
        }, null, 8, ["pageNo", "pageSize", "total"])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    (addUserDrawerVisiable.value)
      ? (_openBlock(), _createBlock(AddUserDrawer, {
          key: 0,
          drawerVisible: addUserDrawerVisiable.value,
          "onUpdate:drawerVisible": _cache[3] || (_cache[3] = ($event: any) => ((addUserDrawerVisiable).value = $event)),
          "add-user-list": addUserList.value,
          onChange: onChangeAddUser
        }, null, 8, ["drawerVisible", "add-user-list"]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})